<template>
  <div class="main-certificate-query">
    <div class="body">
      <div class="seek">
        <img
          class="seek-logo"
          src="@/assets/image/queryCertificate/seek_logo.png"
        />
        <div class="seek-box" style="height: 280px;">
          <h1 style="display: block;">证书查询</h1>
          <img src="@/assets/image/queryCertificate/seek_line.png" />
          <div class="partner">
            <div class="name">
              姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名:
            </div>
            <input
              type="text"
              class="write_box validate"
              style="width: 250px"
              v-model="searchForm.realName"
            />
          </div>
          <div class="partner code">
            <div class="name">
              证件号码:
            </div>
            <input
              type="text"
              class="write_box validate"
              style="width: 250px"
              v-model="searchForm.idNumber"
            />
          </div>
          <div class="partner code">
            <div class="name">
              证书编号:
            </div>
            <input
              type="text"
              class="write_box validate"
              style="width: 250px"
              v-model="searchForm.certificateCode"
            />
          </div>
          <div class="partner code">
            <div class="name">
              验&nbsp;&nbsp;证&nbsp;&nbsp;码:
            </div>
            <input
              type="text"
              maxlength="4"
              class="write_box validate"
              style="width: 150px"
              v-model="searchForm.captchaCode"
            />
            <el-image
              class="validate-img"
              :src="captchaImage"
              @click.native.prevent="captcha"
            >
              <div slot="placeholder" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
          <div class="partner" style="padding-top:20px;">
            <button @click="queryCertificate">
              查询
            </button>
          </div>
        </div>

        <div
          style="text-align: left;margin:40px auto 0;width: 378px;line-height: 28px;"
        >
          注意:<br />
          1.查询证书需经权属人同意。<br />
          2.证书查询结果不得用于违背权属人意愿之用途。<br />
<!--          3.咨询电话：17371568982-->
        </div>

        <!--20230403新增-->
        <a href="http://www.china-capm.org.cn/show?id=437" target="_blank">
          <img style="margin-top: 50px;" src="@/assets/image/queryCertificate/gs-img.jpg" />
        </a>
      </div>

      <div class="result-box">
        <div class="seek-result" v-if="certificate && certificate.userId">
          <el-image
            class="id-img"
            v-if="certificate.idPhoto"
            :src="certificate.idPhoto"
          >
            <div slot="placeholder" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <div class="id-img" v-else></div>
          <div class="result-name">
            <span class="key">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：</span>
            <!--            <a :href="resumeHref" target="_blank">-->
            <span class="value">{{ certificate.realName }}</span>
            <!--            </a>-->
          </div>
          <!--<div class="result-id">
            <span class="key">证件号码：</span
            ><span class="value">{{ certificate.idNumber }}</span>
          </div>-->
          <div class="cer-id">
            <span class="key">证书编号：</span>
            <!--            <template v-if="certificate.certificateFile">-->
            <!--              <span class="has-image value" @click="viewCertificateImg"-->
            <!--                >{{ certificate.certificateCode }}-->
            <!--              </span>-->
            <!--              <el-image-->
            <!--                ref="certificateImg"-->
            <!--                style="width: 0;height: 0;position: absolute"-->
            <!--                :src="certificate.certificateFile"-->
            <!--                :preview-src-list="[certificate.certificateFile]"-->
            <!--              >-->
            <!--              </el-image>-->
            <!--            </template>-->
            <!--            <template v-else>-->
            <span class="value">{{ certificate.certificateCode }}</span>
            <!--            </template>-->
          </div>
          <!--<div class="cer-class">
            <span class="key">证书类别：</span
            ><span class="value">{{ certificate.certificateType }}</span>
          </div>-->
          <div class="cer-level">
            <span class="key">证书等级：</span
            ><span class="value">{{ certificate.certificateLevel }}</span>
          </div>
          <div class="cer-description" v-if="certificate.cerDescription">
            <span class="key">证书描述：</span
            ><span class="value">{{ certificate.cerDescription }}</span>
          </div>
          <div class="cer-time">
            <span class="key">发证时间：</span
            ><span class="value">{{ certificate.issuingDate }}</span>
          </div>
          <!--<div class="cer-time">
            <span class="key">是否会员：</span
            ><span class="value">{{ certificate.vip }}</span>
          </div>-->
        </div>
        <div class="seek-icon" v-else>
          <img src="@/assets/image/queryCertificate/seek-icon.png" />
          <span v-if="certificate">请输入查询条件</span>
          <span v-else style="color:red">未查询到结果</span>
        </div>
      </div>
      <div style="clear: both"></div>
    </div>
  </div>
</template>

<script>
import { queryCertificate } from "@/api/openApi";
import { captcha } from "@/api/auth";

export default {
  name: "QueryCertificate",
  inject: ["reload"],
  data: function() {
    return {
      captchaImage: null,
      searchForm: {
        realName: "",
        idNumber: "",
        certificateCode: "",
        captchaKey: "",
        captchaCode: ""
      },
      certificate: {
        userId: null,
        realName: "",
        idPhoto: "",
        vip: "",
        certificateFile: "",
        idNumber: "",
        certificateCode: "",
        certificateType: "",
        certificateLevel: "",
        issuingDate: "",
        cerDescription: ""
      }
    };
  },
  computed: {
    resumeHref() {
      let routes = this.$router.resolve("resume/" + this.certificate.userId);
      return routes.href;
    }
  },
  watch: {},
  created() {},
  mounted() {
    this.captcha();
  },
  methods: {
    viewCertificateImg() {
      this.$refs.certificateImg.$el
        .getElementsByClassName("el-image__inner")[0]
        .click();
    },
    captcha() {
      captcha().then(res => {
        if (res.code === "200") {
          this.captchaImage = res.data.captchaImage;
          this.searchForm.captchaKey = res.data.captchaKey;
        }
      });
    },
    queryCertificate() {
      let that = this;
      if (!this.searchForm.realName) {
        this.$message.error("姓名不能为空");
        return;
      }
      if (!this.searchForm.idNumber) {
        this.$message.error("证件号码不能为空");
        return;
      }
      if (!this.searchForm.certificateCode) {
        this.$message.error("证书编号不能为空");
        return;
      }
      if (!this.searchForm.captchaCode) {
        this.$message.error("验证码不能为空");
        return;
      }
      queryCertificate(this.searchForm).then(res => {
        if (res.code === "200") {
          that.certificate = res.data;
        }
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
.main-certificate-query {
  .seek-box .code .el-image {
    float: left;
    width: 91px;
    height: 35px;
    margin-left: 10px;
    /*margin-top:2px;*/
    cursor: pointer;
  }
  .seek-result .el-image.id-img {
    width: 120px !important;
    height: 170px;
    margin-bottom: 20px !important;
    border-radius: 2px;
    border: 1px solid #e3e3e3;
  }
  .cer-description .key {
    float: left;
  }
}
</style>
<style rel="stylesheet/scss" lang="scss" scoped>
* {
  padding: 0;
  margin: 0;
}
.main-certificate-query {
  font-family: "微软雅黑";
  font-size: 14px;
  color: #333;
  background-color: #fff;
  overflow-x: hidden;
  background-image: url("~@/assets/image/queryCertificate/seek_bg.jpg");
  background-repeat: no-repeat;

  a {
    color: #333;
  }
  a:link {
    text-decoration: none;
  }
  a:visited {
    text-decoration: none;
  }
  a:hover {
    text-decoration: none;
  }
  a:active {
    text-decoration: none;
  }
  a:hover {
    text-decoration: underline;
  }

  .body {
    width: 1200px;
    margin: 0 auto;
    padding-top: 25px;
    position: relative;
  }

  .seek-logo {
    width: 500px;
    margin: 40px auto 0;
    display: block;
  }

  .seek {
    width: 515px;
    height: 800px;
    text-align: center;
    margin: 50px auto 0;
    float: left;
  }

  .seek .seek-box {
    width: 515px;
    height: 250px;
    background-color: rgba(255, 255, 255, 0.3);
    border-radius: 20px;
    margin-top: 40px;
  }
  .seek .seek-box h1 {
    font-size: 24px;
    color: #e60012;
    font-weight: initial;
    display: inline-block;
    padding: 10px 0;
  }
  .seek-box .partner {
    width: 378px;
    margin: 20px auto 0;
    padding: 12px 0;
  }
  .seek-box .partner .name {
    float: left;
    width: 60px;
    height: 35px;
    text-align: right;
    line-height: 35px;
  }
  .seek-box .partner .write_box {
    float: left;
    width: 290px;
    height: 35px;
    background-color: #fff;
    border: 0.5px solid #d70000;
    border-radius: 5px;
    margin-left: 10px;
    padding-left: 5px;
  }
  .seek-box .code {
    /*margin-top:95px;*/
  }

  .seek-box .code .write_box {
    width: 115px;
  }
  .seek button {
    width: 100px;
    height: 35px;
    font-size: 14px;
    background-color: #d70000;
    color: #fff;
    border: none;
    border-radius: 10px;
    cursor: pointer;
  }

  .result-box {
    width: 650px;
    background-color: rgba(255, 255, 255, 0.6);
    height: 800px;
    position: absolute;
    top: 0;
    right: 0;
    padding-top: 90px;
  }

  .seek-icon {
    width: 300px;
    margin: 200px auto 0;
    text-align: center;
  }
  .seek-icon img {
    width: 100px;
  }
  .seek-icon span {
    display: block;
    color: #999;
    margin-top: 20px;
  }
  .seek-result {
    width: 400px;
    text-align: center;
    margin: 0 auto;
    padding: 60px 0;
    /*background-color:rgba(255,255,255,0.6);*/
    border-radius: 20px;
  }
  .seek-result div {
    width: 330px;
    margin: 30px auto 0;
    text-align: left;
  }
  .seek-result div .key {
    width: 90px;
    display: inline-block;
    text-align: center;
    color: #777;
    font-size: 16px;
  }
  .seek-result div .value {
    width: 240px;
    display: inline-block;
    font-weight: bold;
    font-size: 16px;
  }
  .seek-result .result-name .value:hover {
    cursor: pointer;
    color: #d70000;
    text-decoration: underline;
  }
  .seek-result .cer-id {
    position: relative;
  }
  .seek-result .cer-id .has-image.value:hover {
    cursor: pointer;
    color: #d70000;
    text-decoration: underline;
  }
}
</style>
